import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'
import { headerStatStyles } from '../dynamic-widget/styled'

export const FunnelStatisticStyled = styled.div`
  && {
    padding: 10px;
    height: ${props => (props.isDashboard ? '100%' : 'auto')};
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  ${headerStatStyles}

  .card-container {
    text-align: left;
    background-color: ${colors.white};
    padding: 30px 20px;
    min-width: 200px;
    min-height: 448px;
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
  }
  
  .full{
    width: 100%;
  }
  
  .label-stat {
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.blackAlpha80};
    margin: 0;
    margin-bottom: 20px;
  }
    
  .funnel-title {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  
  .extra-data {
    font-size: 14px;
  }

  /* En el panel los tramos llenan el alto que deja la cabecera; fuera del panel, 56 px cada uno */
  .funnel-body {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
  }

  .funnel-row {
    flex: ${props => (props.isDashboard ? '1 1 0' : '0 0 56px')};
    min-height: 32px;
    display: flex;
    align-items: stretch;
    gap: 16px;
    border-top: 1px solid ${tokens.color.border.subtle};

    :last-child {
      border-bottom: 1px solid ${tokens.color.border.subtle};
    }
  }

  .value-stat {
    position: relative;
    flex: 0 0 55%;
    z-index: 0;
  }

`

const funnel_polygon = ({top, bottom}) => {
    return `polygon(${50 - top/2}% 0, ${top/2  + 50}% 0, ${bottom/2 + 50}% 100%, ${50 - bottom/2}% 100%)`;
}

export const FunnelItem = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.primary+props.opacity};
  clip-path: ${props => funnel_polygon(props)};
`
export const FunnelValue = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: ${tokens.color.text.primary};
  z-index: 1;
`

export const FunnelInfo = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  .funnel-title{
    color: ${colors.blackAlpha50};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
 .funnel-value{
    color: ${colors.blackAlpha80};
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
`
